var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-carousel',{class:{ 'is-full': _vm.isFull },attrs:{"config":_vm.configComputed,"prev-title":_vm.prevTitle,"next-title":_vm.nextTitle}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }